export default "__VITE_ASSET__7f16798f__"